//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getExtensionFromString } from '~/utils/helpers';

export default {
  name: 'UiInfoDocumentsItem',
  props: {
    blok: {
      type: Object,
      required: true,
    },
    theme: {
      type: String,
      validator: type => ['grouped'].includes(type),
    },
  },
  computed: {
    filename() {
      return this.blok.file?.filename;
    },
    extension() {
      if (this.blok.is_manual_extension) return this.blok.extension || '';

      const extension = this.filename && getExtensionFromString(this.filename);
      return extension?.toUpperCase() || '';
    },
  },
}
